/**
 * This app is deployed at elevaplatform.org. The marketing pages (about,
 * features, creators, contact, download) are React routes under
 * features/landing; the legal pages are same-origin static files served from
 * public/legal (no React needed to read them). The legal paths must not
 * change: the native apps hard-code them as absolute
 * https://elevaplatform.org/… URLs -
 *  - eleva-ios:      Eleva/Profile/SettingsScreen.swift, Eleva/Auth/Views/AgreementsScreen.swift
 *  - eleva-android:  feature/profile/SettingsScreen.kt,  feature/auth/AgreementsScreen.kt
 * The old static marketing files (public/about.html, …) are kept only as
 * redirects to the routes below, for app builds and links that still use them.
 */
export const elevaLinks = {
  home: '/',
  about: '/about',
  features: '/features',
  creators: '/creators',
  contact: '/contact',
  download: '/download',
  legal: {
    termsOfService: '/legal/terms-of-service.html',
    privacyPolicy: '/legal/privacy-policy.html',
    communityGuidelines: '/legal/community-guidelines.html',
    childSafetyStandards: '/legal/child-safety-standards.html',
    cookiePolicy: '/legal/cookie-policy.html',
    monetisationPolicy: '/legal/monetisation-policy.html',
    virtualItemsPolicy: '/legal/virtual-items-policy.html',
    kycDisclosure: '/legal/kyc-disclosure.html',
    eula: '/legal/eula.html',
    deleteAccount: '/legal/delete-account.html',
  },
} as const

/** Routes rendered with the landing chrome (LandingNav + LandingFooter). */
export const marketingPaths: ReadonlySet<string> = new Set([
  '/welcome',
  elevaLinks.about,
  elevaLinks.features,
  elevaLinks.creators,
  elevaLinks.contact,
  elevaLinks.download,
])

export const appStores = {
  android: 'https://play.google.com/store/apps/details?id=org.elevaplatform.mobile.Eleva',
  // "Eleva Social" listing (App Store Connect adamId). Apple redirects to the
  // visitor's storefront path; the id form never goes stale on a rename.
  ios: 'https://apps.apple.com/app/id6787748315',
} as const

/** Registered-company details shown in legal footers (not translated). */
export const elevaCompany = {
  name: 'Eleva Platform Ltd',
  registration: 'Company No. 17158073',
  companyNumber: '17158073',
  address: '4A Central Square, Liverpool, L31 0AQ, United Kingdom',
  website: 'elevaplatform.org',
  generalEmail: 'hello@elevaplatform.org',
  supportEmail: 'support@elevaplatform.org',
  privacyEmail: 'privacy@elevaplatform.org',
  pressEmail: 'press@elevaplatform.org',
} as const
